import { TableNames } from "../../enums/tableNames";
import WorklistPage from "./components/worklistPage";
import { CallingWorklistView } from "./utils/buildWorklistFilters";

/** Non-ePA worklist: every order flagged for outreach (`non_epa_required: [yes]`). */
const CallingWorklist = () => (
  <WorklistPage
    heading="Non-ePA Orders"
    view={CallingWorklistView.NON_EPA}
    tableName={TableNames.CALLING_WORKLIST_ORDERS}
  />
);

export default CallingWorklist;
